import { Component, ViewChild, ElementRef, NgModule, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgApexchartsModule, ApexNonAxisChartSeries, ApexPlotOptions, ApexChart, ApexFill, ChartComponent, ApexAxisChartSeries, ApexDataLabels, ApexYAxis, ApexXAxis, ApexTooltip, ApexStroke, ApexLegend, ApexTitleSubtitle, } from "ng-apexcharts";
import { OneSignal } from 'onesignal-ngx';
import { AdmindasboardservicesService } from 'src/app/shared/services/admindasboardservices.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { AnimationOptions } from 'ngx-lottie';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LottieComponent } from 'ngx-lottie';
import { NewsUpdatesComponent } from 'src/app/shared/components/news-updates/news-updates.component';
declare let $: any;
@Component({
  selector: 'app-new-admin-dashboard',
  templateUrl: './new-admin-dashboard.component.html',
  styleUrl: './new-admin-dashboard.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, LottieComponent, ChartComponent, NewsUpdatesComponent, NgApexchartsModule],
})
export class NewAdminDashboardComponent implements OnInit {
  @ViewChild('acceptleaveModalCenter') acceptLeaveModal!: ElementRef;
  @ViewChild('rejectleaveModalCenter') rejectLeaveModal!: ElementRef;


  linechartOptions: any;
  showSpinner = true;
  newChartOptions: any = {
    chart: {},
    labels: [],
    colors: [],
    plotOptions: {},
    legend: {},
    dataLabels: {},
    stroke: {}
  };

  newChartData: any[] = [];
  // chartOptions: any;
  // newChartOptions: any;
  imagchartOptions: any;
  public optionsProgress3: any;
  aniversarydays: any;

  donutChartOptions: any = {
    chart: { type: 'donut', height: 250 },
    labels: [],
    colors: [],
    plotOptions: {},
    legend: {},
    dataLabels: {},
    stroke: {}
  };

  donutChartData: any = [];
  punchindata: any;
  punchoutdata: any;
  attendancedata: any;
  // chartData: any;
  total_absent: any;
  late_check_in: any;
  miss_checkOut: any;
  overtime: any;
  goodWork: any;
  total_shorttime: any;
  evaluation_point: any;
  evalution: any;
  selectedDuration = 'today';
  attendanceDuration = 'today';
  leaveslogs: any = {};
  countlogs: any = {};
  subdepartment_count: any;
  donutChartLabels: any;
  selectedTab = 'leave';
  datarequest: any;
  count: any;
  notify: any;
  attendcount: any;
  Attendanceotificaton: any;
  lonecount: any;
  loannotification: any;
  refresh: any;
  user: any;
  birthday: any;
  att_shift_start_time: any;
  att_shift_end_time: any;
  att_total_hours: any;
  org_lat: any;
  org_long: any;
  media: any[] = [];
  years_count: any;
  anniversary_count: any;
  aniversaryhours: any;
  aniversaryminutes: any;
  aniversaryseconds: any;
  previousAnniversaryDays: any;
  runningTimer: any;
  rejected_leave_id: any;
  rejected_leave_index: any;
  arr: any;
  leaveselectedId: any;
  id1: any;
  attendence_id1: any;
  check_in1: any;
  check_out1: any;
  overtime1: any;
  working_hours: any;
  status1: any;
  type1: any;
  check_out: any;
  id: any;
  attendence_id: any;
  check_in: any;
  reason: any = '';
  status: any;
  type: any;
  RejectionData: any;
  reason1: any = '';
  reasonModal: any;
  loaid: any;
  loanid: any;
  user_role: any;
  roleType: any;
  mediaObject: any[] = [];
  isNewsUpdateShow = false;
  isMedia = false;
  isNewsUpdateModalShow = true;
  admin_id1: any;
  admin_reason1: any;
  acceptanceData: any;
  userInfo: any;
  chartOptions: any = {}; // Initialize as an empty object to prevent undefined errors
  chartData: any[] = []; // Ensure chartData is defined
  leaveRequests: any;
  attendanceRequests: any;
  loanRequests: any;
  hasEvaluationData = false;
  showNoDataImage = false;
  options: AnimationOptions = {
    path: '../../assets/noData.json',
  };
  notify1: any = {};
  latestAnnouncement: any;
  latestAnnoument: any;
  annouceDescription: any;
  showDescription = false;
  announcementfiles: any;
  annoucesstatus: any;
  constructor(
    public dashboardService: DashboardService,
    public router: Router,
    private admindasboardServices: AdmindasboardservicesService,
    public addService: AddService,
    private mediaService: MediaService,
    private leaveService: LeaveService,
    private settings: SettingservicesService,
    private oneSignal: OneSignal


  ) {
    const userInfo = localStorage.getItem('user');
    if (userInfo != null) {
      this.user = JSON.parse(localStorage.getItem('user') || '') || '';
    }
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    if (this.roleType !== 'Admin') {
      this.router.navigate(['/dashboard-1']);
    }
  }




  ngOnInit() {
    this.getData()
    this.getAnnouncement();

    this.getpunchinData(this.attendanceDuration);
    this.getpunchoutData(this.attendanceDuration);
    this.initializeProgressChart();
    this.Shownotificaton(this.count);
    this.Attendancenotificaton(this.Attendanceotificaton);
    this.Loannotificaton(this.lonecount);
    this.employees_evaluation();
    this.fetchData(this.selectedTab);
    this.headcounts();

    this.user_refresh();
    this.getattendanceData(this.attendanceDuration);
    this.runningTimer = setInterval(() => { this.Running() }, 1000);

    this.Shownotificatonleave(this.count);
    // this.fetchtabsData();
  }

  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.showMedia();

      this.refresh = value?.data?.user;
      this.userInfo = value?.data?.user;
      this.user = this.refresh;
      this.birthday = this.user.dob
      if (this.birthday) {
        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (datePattern.test(this.birthday)) {
          const date = new Date(this.birthday);
          const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short' };  // Day and abbreviated month (e.g., "4 Aug")
          this.birthday = date.toLocaleDateString('en-GB', options); // Apply the formatting
        }
      }
      this.att_shift_start_time = this.user.shift_start_time;
      this.att_shift_end_time = this.user.shift_end_time;
      this.att_total_hours = this.user.total_working_hours || this.user.usershittime[0]?.total_working_hours;
      this.org_lat = this.refresh?.organization?.address.latitude;
      this.org_long = this.refresh?.organization?.address.longitude;
      localStorage.setItem('user', JSON.stringify(value?.data?.user));

      const test_user = localStorage.getItem("user");
      const user_role = JSON.parse(this.user.user_role.user_roles)
    })
  }

  showMedia(): void {
    const newMedia: any[] = [];

    this.mediaService.showMedia().subscribe(
      (response: any) => {
        if (response.success && response.data?.length) {
          newMedia.push(
            ...response.data.filter((item: any) => item?.path && item.path !== 'nill')
          );

          if (newMedia.length > 0) {
            const shuffledMedia = newMedia.sort(() => 0.5 - Math.random());
            this.media = shuffledMedia.slice(0, 6);

          } else {
            console.warn('No valid media paths were found.');
          }
        } else {
          console.warn('No data returned from the API.');
        }
      },
      (error) => {
        console.error('Error fetching media:', error);
      }
    );
    // this.getannouncement()
  }
  getImagePath(): string {
    return `${environment.imageBaseURL}`;
  }


  private initializeProgressChart(): void {
    const totalDays = 365;
    const currentDays = this.aniversarydays;
    const progressPercentage = (currentDays / totalDays) * 100;

    this.optionsProgress3 = {
      chart: {
        height: 70,
        type: "bar",
        stacked: true,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "20%",
          borderRadius: 6, // Apply border radius to the main bar
          colors: {
            backgroundBarColors: ["#f7f5f5"], // Background bar color
            backgroundBarRadius: 6, // Apply the same border radius to the background bar
          },
        },
      },
      colors: ["#1DBFC8"], // Solid bar color
      stroke: {
        width: 0,
      },
      series: [
        {
          name: "Process 3",
          data: [progressPercentage],
        },
      ],
      fill: {
        // type: "solid", // Use solid fill
        colors: ["#1DBFC8"], // Single solid color
      },
      tooltip: {
        enabled: false,
      },
      xaxis: {
        categories: ["Process 3"],
      },
      yaxis: {
        max: 100,
      },
    };
  }


  onattendaceDuration(event: Event): void {
    const duration = (event.target as HTMLSelectElement).value;
    this.getpunchinData(duration);
    this.getpunchoutData(duration);
    this.getattendanceData(duration);

  }
  getpunchinData(duration: any) {
    const time = duration
    this.dashboardService.punchinlogs(time).then((value) => {
      if (value.success == true) {
        this.punchindata = value?.data;
        // Extract data or set default values
        this.chartData = [
          this.punchindata?.total_from_portal,
          this.punchindata?.total_mobile_portal,
          this.punchindata?.total_web_portal,
          this.punchindata?.total_attendance_machine
        ];

        // Check if all values are 0
        const isDataEmpty = this.chartData.every((value: any) => value === 0);

        if (isDataEmpty) {
          // Use fake data and colors when no real data is available
          this.chartData = [1]; // Placeholder data
          this.chartOptions = {
            chart: {
              type: 'donut',
              width: 130,
            },
            labels: ['No Data Found'], // No labels
            colors: ['#CFF1F4'], // Placeholder color (light gray)
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: false, // Hide center labels
                  },
                },
              },
            },
            stroke: {
              show: false,
              width: 0,
            },
            dataLabels: {
              enabled: false, // Hide data labels
            },
            tooltip: {
              enabled: false, // Disable tooltips
            },
            legend: {
              show: false, // Hide legend
            },
          };
        } else {
          // Real data and colors
          this.chartOptions = {
            chart: {
              type: 'donut',
              width: 130,
            },
            labels: [
              'Portal',
              'Mobile Portal',
              'Web Portal',
              'Attendance Machine'
            ],
            colors: ['#52829a', '#129fa2', '#2c9cd2'],
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: false,
                  },
                },
              },
            },
            stroke: {
              show: false,
              width: 0,
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              enabled: false,
            },
            legend: {
              show: false,
            },
          };
        }
      } else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: `Error in Getting Punch In Data`,
          showConfirmButton: false,
          timer: 2000,
        })
      }

    });
  }
  getpunchoutData(duration: any) {
    const time = duration
    this.dashboardService.punchoutlogs(time).then((value) => {
      if (value.success == true) {
        this.punchoutdata = value?.data;
        this.newChartData = [
          this.punchoutdata?.total_from_portal,
          this.punchoutdata?.total_mobile_portal,
          this.punchoutdata?.total_web_portal
        ];

        const isPunchOutDataEmpty = this.newChartData.every((value: any) => value === 0);

        if (isPunchOutDataEmpty) {
          this.newChartData = [1];
          this.newChartOptions = {
            chart: {
              type: 'donut',
              width: 130,
            },
            labels: ['No Data Found'],
            colors: ['#C9BFEE'],
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: false,
                  },
                },
              },
            },
            stroke: {
              show: false,
              width: 0,
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              enabled: false,
            },
            legend: {
              show: false,
            },
          };
        } else {
          this.newChartOptions = {
            chart: {
              type: 'donut',
              width: 130,
            },
            labels: [
              'Portal',
              'Mobile Portal',
              'Web Portal'
            ],
            colors: ['#129fa2', '#1a68ce', '#86b36a'],
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: false,
                  },
                },
              },
            },
            stroke: {
              show: false,
              width: 0,
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              enabled: false,
            },
            legend: {
              show: false,
            },
          };
        }

      } else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: `Error in Getting Punch Out Data`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    });
  }
  getattendanceData(duration: any) {
    const time = duration
    this.dashboardService.attendancetlogs(time).then((value) => {
      if (value.success == true) {
        this.attendancedata = value?.data;
        this.total_absent = this.attendancedata?.absent
        this.late_check_in = this.attendancedata?.late_check_in
        this.miss_checkOut = this.attendancedata?.check_in_no_check_out
        this.overtime = this.attendancedata?.overtime
        this.goodWork = this.attendancedata?.good_attendance
        this.total_shorttime = this.attendancedata?.short_time
      } else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: `Error in Getting Attendance Data`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    });
  }
  getTooltipText(): string {
    if (!this.subdepartment_count || this.subdepartment_count.length <= 5) {
      return 'No data available';
    }
    return this.subdepartment_count
      .slice(5) // Get data from index 5 onward
      .map(
        (item: any) =>
          `${item?.department || '0'},  ${item?.user_count || '0'}`
      )
      .join(' | ');
  }
  employees_evaluation() {
    this.admindasboardServices.getemployeesevaluation().then((value) => {
      if (value?.data && value.data.length > 0) {
        this.evalution = value.data;
        this.hasEvaluationData = true;

        this.linechartOptions = {
          series: [
            {
              name: 'PM Points',
              data: this.evalution.map((item: any) => item.pm_points)
            }
          ],
          chart: {
            type: 'area',
            height: 220,
            toolbar: { show: false }
          },
          xaxis: {
            categories: this.evalution.map(
              (item: any) => `${item?.users?.first_name} ${item?.users?.last_name}`
            ),
            labels: { style: { fontSize: '10px' } }
          },
          yaxis: { min: 0, max: 10 },
          dataLabels: { enabled: false },
          stroke: { curve: 'straight', colors: ['#00989B'] },
          markers: {
            size: 6,
            colors: ['#FFFFFF'],
            strokeColors: '#00989B',
            strokeWidth: 2,
            hover: { size: 8 }
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              gradientToColors: ['#00989B'],
              inverseColors: true,
              opacityFrom: 0.6,
              opacityTo: 0.1,
              stops: [0, 100]
            }
          },
          tooltip: {
            enabled: true,
            y: { formatter: (val: number) => val.toFixed(2) }
          }
        };
      } else {
        console.warn("No evaluation data available");
        this.evalution = [];
        this.hasEvaluationData = false;
      }

      this.fetchLeavesLog(this.selectedDuration);
    }).catch((error) => {
      console.error("Error fetching employee evaluation:", error);
      this.hasEvaluationData = false;
    });
  }

  onDurationChange(event: Event): void {
    const duration = (event.target as HTMLSelectElement).value;
    this.fetchLeavesLog(duration);
  }
  fetchLeavesLog(duration: string): void {
    this.admindasboardServices.getLeaveslog(duration).then((value) => {
      if (value.success == true) {
        this.leaveslogs = value?.data;
      }
      else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: `Error in Getting Leaves Data`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    })
  }

  headcounts() {
    this.admindasboardServices.headCounts().then((value) => {
      if (value.success == true) {
        this.countlogs = value?.data;
        this.subdepartment_count = value?.data?.users_by_sub_department
        this.donutChartData = this.subdepartment_count.map((item: any) => item.user_count);
        this.donutChartLabels = this.subdepartment_count.map((item: any) => item.department);
        this.donutChartOptions = {
          chart: {
            type: 'donut',
            width: 200,
          },
          labels: this.donutChartLabels,
          colors: ['#59DAE3', '#B9A081', '#D3D3E5', '#987EC7', '#60BD68', '#C6A1E4', '#4CBBB9', '#457992', '#1C94CF'],
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                }
              }
            }
          },
          stroke: {
            show: false,
            width: 0
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          legend: {
            show: false
          }
        };
        // this.fetchData(this.selectedTab);
      }
      else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: `Error in Getting Leaves Data`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    })
  }


  // fetchtabsData(){

  //   this.fetchData('leave');
  //   this.fetchData('attendance');
  //   this.fetchData('loan');


  // }

  onTabSelect(tab: string): void {
    
    this.selectedTab = tab;
    this.fetchData(tab);
  }

  fetchData(requestType: string): void {
    this.showSpinner = true;
    this.admindasboardServices.requestData(requestType).then((value) => {
      if (value.success == true) {
        this.datarequest = value?.data;
        if (requestType === 'leave') {
          this.leaveRequests = value.data || [];
        } else if (requestType === 'attendance') {
          this.attendanceRequests = value.data || [];
        } else if (requestType === 'loan') {
          this.loanRequests = value.data || [];
        }
        this.showNoDataImage =
          this.leaveRequests.length === 0 &&
          this.attendanceRequests.length === 0 &&
          this.loanRequests.length === 0;

        if (!this.selectedTab) {
          if (this.leaveRequests?.length > 0) {
            this.selectedTab = 'leave';
          } else if (this.attendanceRequests?.length > 0) {
            this.selectedTab = 'attendance';
          } else if (this.loanRequests?.length > 0) {
            this.selectedTab = 'loan';
          }
        }
      } else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: `Error in Getting Request Data`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
      this.showSpinner = false;
    }).catch((error) => {
      console.error('API Error:', error);
    });

  }

  calculateDaysAndFormatRange(startDate: string, endDate: string): { totalDays: number, dateRange: string } {
    if (!startDate || !endDate) {
      return { totalDays: 0, dateRange: '' };
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    const totalDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    const startDay = start.getDate();
    const endDay = end.getDate();

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const startMonth = monthNames[start.getMonth()];
    const endMonth = monthNames[end.getMonth()];

    let dateRange: string;

    if (startMonth === endMonth && startDay === endDay) {
      dateRange = `${startDay} of ${startMonth}`;
    } else if (startMonth === endMonth) {
      dateRange = `${startDay} to ${endDay} of ${startMonth}`;
    } else {
      dateRange = `${startDay} of ${startMonth} to ${endDay} of ${endMonth}`;
    }

    return { totalDays, dateRange };
  }

  Shownotificaton(count: any) {
    this.count = "leave_request";
    this.addService.showNotify(this.count).then((value) => {
      this.notify = value?.data;
    })
  }

  Attendancenotificaton(attendancecount: any) {
    this.attendcount = "attendance_request";
    this.addService.attendanceNotify(this.attendcount).then((value) => {
      this.Attendanceotificaton = value?.data;
    })

  }

  Loannotificaton(lonecount: any) {
    this.lonecount = "loan_request";
    this.addService.loanNotify(this.lonecount).then((value) => {
      this.loannotification = value?.data;
    })
  }





  Running() {
    const countDownDate = new Date(this.user?.joining_date).getTime();

    this.anniversary_count = "1st"
    // Get today's date and time
    const now = new Date().getTime();
    let distance = now - countDownDate;
    distance = Math.abs(distance);
    let years_day = Math.floor(distance / (1000 * 60 * 60 * 24))
    years_day = Math.abs(years_day);
    // alert(years_day)
    if (years_day >= 365) {
      this.years_count = Math.floor(years_day / 365);
      years_day = years_day - (365.2 * this.years_count)
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    } else {
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    }
    this.aniversarydays = (years_day).toString();
    this.aniversaryhours = (24 - Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).toString();
    this.aniversaryminutes = (60 - Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).toString();
    this.aniversaryseconds = (60 - Math.floor((distance % (1000 * 60)) / 1000)).toString();
    if (this.aniversarydays !== this.previousAnniversaryDays) {
      // Update the chart if the value has changed
      this.initializeProgressChart();
      // Update the previous anniversary days value
      this.previousAnniversaryDays = this.aniversarydays;
    }


    if (this.years_count === 1) {
      this.anniversary_count = "2nd"
    } else if (this.years_count === 2) {
      this.anniversary_count = "3rd"
    } else if (this.years_count > 2) {
      this.anniversary_count = this.years_count + "th"
    }
  }

  approveleave(data: any) {
    this.showSpinner = true;

    const id = data.id

    let status;
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      status = 'approved';
    }
    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (data.approval_or_recommendation == 0) {
        status = 'recommended';
      } else if (data.approval_or_recommendation == 1) {
        status = 'approved';
      }
    }
    this.leaveService.getLeaveApproved(id, status).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Approved Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
      this.showSpinner = false;
    });

  }

  deleteleave(id: any) {
    const leaveid = id
    this.showSpinner = true;
    this.leaveService.deleteLeave(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Approved Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
      this.showSpinner = false;
    });
  }



  leaveRejectionData: any;
  gettextauto: any;
  getTextForAutomation() {
    this.showSpinner = true;
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data;
      this.leaveRejectionData = this.gettextauto.filter((item: any) => item.title.trim() === "LEAVE_REJECTION_TEXT");
      this.RejectionData = this.gettextauto.filter((item: any) => item.title.trim() === "ATTENDANCE_REJECTION_TEXT");
      this.acceptanceData = this.gettextauto.filter((item: any) => item.title.trim() === "ATTENDANCE_ACCEPTENCE_TEXT");
      this.showSpinner = false;
    })
  }


  rejectedReason = '';
  setReason(text: string) {
    this.rejectedReason = text;
    this.reason1 = this.rejectedReason;
    this.reasonModal = this.rejectedReason;
  }

  openRejectModal(id: number): void {
    this.leaveselectedId = id;
    this.getTextForAutomation();

  }

  reject(reason: NgForm) {
    const id = this.leaveselectedId;
    const rejected_reason = reason.value.rejected_reason;
    this.showSpinner = true;
    this.leaveService.rejectLeave(id, rejected_reason).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Rejected Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
    });
  }




  sendAcceptedData(data: any) {
    this.id1 = data.id;
    this.attendence_id1 = data.attendance_id;
    this.check_in1 = data.check_in;
    this.check_out1 = data.check_out;
    this.overtime1 = data.overtime;
    this.working_hours = data.working_hours;
    this.status1 = 'approved';
    this.type1 = data.type;
    this.getTextForAutomation();
  }
  sendRejectedData(data: any) {
    this.id1 = data.id;
    this.attendence_id1 = data.attendance_id;
    this.check_in1 = data.check_in;
    this.check_out1 = data.check_out;
    this.overtime1 = data.overtime;
    this.working_hours = data.working_hours
    this.status1 = 'rejected';
    this.type1 = data.type;
    this.getTextForAutomation();
  }
  aproveReq(attendance: NgForm) {

    this.showSpinner = true;
    this.id = this.id1;
    this.attendence_id = this.attendence_id1;
    this.check_in = this.check_in1;
    this.check_out = this.check_out1;
    this.working_hours = this.working_hours;
    this.overtime = this.overtime1;
    this.status = this.status1;
    this.type = this.type1;
    this.admin_id1 = this.userInfo.id;
    this.reason = attendance.value.reason;
    this.addService.getapprove(this.id, this.attendence_id, this.check_in, this.check_out, this.working_hours, this.overtime, this.status, this.type, this.admin_id1, this.reason).then((value) => {
      this.showSpinner = false;
    });
  }
  rejectReq(attendance: NgForm) {
    this.showSpinner = true;
    this.id = this.id1;
    this.attendence_id = this.attendence_id1;
    this.check_in = this.check_in1;
    this.check_out = this.check_out1;
    this.working_hours = this.working_hours
    this.overtime = this.overtime1;
    this.status = this.status1;
    this.type = this.type1;
    this.admin_id1 = this.userInfo.id;
    this.reason = this.reason1;
    this.addService.getapprove(this.id, this.attendence_id, this.check_in, this.check_out, this.working_hours, this.overtime, this.status, this.type, this.admin_id1, this.reason).then((value) => {
      this.showSpinner = false;
    });
  }

  isavailablefeatureforLeave(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.leave_data?.data?.values;

    switch (type) {
      case "isView":
        return values?.view_leave ?? false;

      case "isAccept":
        return values?.accept ?? false;

      case "isReject":
        return values?.reject ?? false;

      default:
        return false;
    }
  }
  isavailablefeature(type: string): boolean {

    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.attendance_data?.data?.values;

    switch (type) {
      case "isView":
        return values?.view_attedance ?? false;

      case "isAccept":
        return values?.edit ?? false;

      case "isReject":
        return values?.delete ?? false;

      default:
        return false;
    }
  }
  isLoanApprovedPermission(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.team_managment?.data?.values;
    switch (type) {
      case "isloanView":
        return values.loanView ?? false
      case "isAccept":
        return values.loanAccept ?? false
      case "isReject":
        return values.loanReject ?? true
      default:
        return false;
    }
    return false;

  }
  // isavailablefeature(type: string): boolean {
  //   switch (type) {
  //     case "isAccept":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.attendance_data.data.values.edit === false
  //     case "isReject":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.attendance_data.data.values.delete === false
  //     default:
  //       return false;
  //   }
  //   return false
  // }
  setloanData(data: any) {
    this.loanid = data?.id
  }

  aproveLoan(loan: NgForm) {
    this.showSpinner = true;
    const id = this.loanid
    const action = "approved"
    this.addService.getLoanApprove(id, action).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Request Accepted',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
    })

  }
  rejetcLoan(loan: NgForm) {
    this.showSpinner = true;
    const id = this.loanid
    const action = "reject"
    this.addService.getLoanApprove(id, action).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Request Rejected',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
    })

  }


  getLargestSource(): string {
    const mobile = this.punchindata?.total_mobile_portal || 0;
    const portal = this.punchindata?.total_web_portal || 0;
    const machine = this.punchindata?.total_attendance_machine || 0;

    if (mobile > 0 || portal > 0 || machine > 0) {
      if (mobile >= portal && mobile >= machine) {
        return 'mobile';
      } else if (portal >= mobile && portal >= machine) {
        return 'portal';
      } else {
        return 'machine';
      }
    } else {
      return 'no_data'
    }
  }


  getLargestoutSource(): string {
    const mobile = this.punchoutdata?.total_mobile_portal || 0;
    const portal = this.punchoutdata?.total_web_portal || 0;
    const machine = this.punchoutdata?.total_attendance_machine || 0;
    if (mobile > 0 || portal > 0 || machine > 0) {
      if (mobile >= portal && mobile >= machine) {
        return 'mobile';
      } else if (portal >= mobile && portal >= machine) {
        return 'portal';
      } else {
        return 'machine';
      }
    } else {
      return 'no_data'
    }

  }


  getData() {

    this.dashboardService.getDashboardData().then((value) => {

      this.mediaObject = value?.media;
      if (value.media != null && value?.media != undefined && value?.media?.length > 0) {
        this.isNewsUpdateShow = true;
      }

      if (localStorage.getItem('userDeviceID_OneSignal_subcripptio') == "" || localStorage.getItem('userDeviceID_OneSignal_subcripptio') == null) {
        //Get ID for Onesignla External ID
        const userID = this.user?.id ?? "15500"
        this.oneSignal.login(String(userID)).then(value => {
          const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
          if (userDeviceID_OneSignal_subcripptio.length > 5) {
            localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
          }
        })
        const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
        if (userDeviceID_OneSignal_subcripptio.length > 5) {
          localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
        }
      }
      this.showSpinner = false;

    });
  }

  closeModal() {
    $('#acceptleaveModalCenter').modal('hide');
    $('#rejectleaveModalCenter').modal('hide');
  }


  showNoData(): boolean {
    const hasData = this.datarequest?.length > 0;
    const noData = !hasData;

    switch (this.selectedTab) {
      case 'leave':
        console.log(noData && this.isavailablefeatureforLeave('isView'));
        return noData && this.isavailablefeatureforLeave('isView');


      case 'attendance':
        console.log(noData && this.isavailablefeature('isView'));

        return noData && this.isavailablefeature('isView');

      case 'loan':
        console.log(noData && this.isLoanApprovedPermission('isloanView'));
        return noData && this.isLoanApprovedPermission('isloanView');

      default:
        return false;
    }
  }

  Shownotificatonleave(count: any) {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type != "Team_Lead") {

      this.count = "leave_request";
      this.addService.leaveNotify().then((value) => {
        this.notify1 = value.data
      })
    }
  }



  settodayattendance() {
    this.showSpinner = true;

    this.addService.settodayattendance().then((value) => {
      if (value.success == true) {
        this.router.navigate(['/attendance-management'], { state: { type: 'absent' } });
        this.showSpinner = false;
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 2000,
        });
        this.showSpinner = false;
      }

    })

  }



  getAnnouncement() {
    this.showSpinner = true;

    this.dashboardService.getAnnouncement().then((value) => {

      this.latestAnnoument = value?.data;
      this.annouceDescription = this.latestAnnoument?.description
      this.annoucesstatus = this.latestAnnoument?.status
      if (this.annouceDescription != '' && this.annouceDescription != null) {
        this.showDescription = true;
      }

      this.announcementfiles = this.latestAnnoument?.files

    });
  }

  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif)$/i.test(file);
  }

  // Check if file is video
  isVideo(file: string): boolean {
    return /\.(mp4|mov|ogg)$/i.test(file);
  }

  getReactions(reactionCounts: any): { type: string, count: number }[] {
    if (!reactionCounts) return [];
    return Object.keys(reactionCounts).map(type => ({
      type,
      count: reactionCounts[type]
    }));
  }

  // Map reaction type → image path
  getReactionImage(type: string): string {
    switch (type) {
      case 'wow': return 'assets/announcement/wow.svg';
      case 'love': return 'assets/announcement/heart.svg';
      case 'like': return 'assets/announcement/like.svg';
      case 'dislike': return 'assets/announcement/dislike.svg';
      case 'angry': return 'assets/announcement/angry.svg';
      case 'upset': return 'assets/announcement/upset.svg';
      case 'laugh': return 'assets/announcement/laugh.svg';
      default: return 'assets/announcement/like.svg';
    }
  }
  get firstFile(): string | null {
    return this.announcementfiles && this.announcementfiles.length > 0
      ? this.announcementfiles[0]
      : null;
  }
}
